import { CSSProperties } from 'react';

import { cn } from '../../helpers/classBuilders';
import { PropsWithClassName } from '../../types/common';

interface SkeletonProps extends PropsWithClassName {
  width: number | string;
  height: number | string;
  variant?: 'default' | 'circle';
}

export const Skeleton = ({
  width,
  height,
  variant = 'default',
  className,
}: SkeletonProps) => {
  const variantStyles: Record<string, CSSProperties> = {
    default: {
      width: typeof width === 'number' ? `${width}px` : width,
      height: typeof height === 'number' ? `${height}px` : height,
      borderRadius: '8px',
    },
    circle: {
      width: typeof width === 'number' ? `${width}px` : width,
      height: typeof height === 'number' ? `${height}px` : height,
      borderRadius: '50%',
    },
  };

  return (
    <div
      role="status"
      className={cn('bg-gray-200 animate-pulse', className)}
      style={{
        ...variantStyles[variant],
      }}
    />
  );
};
